module.exports = __webpack_public_path__ + "assets/img/pdc-couts-impression.cfa2d90c.jpg";